import React, { useState } from 'react';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="w-full border-b border-gray-200 bg-white/70 backdrop-blur-sm relative z-50">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-6">
          <a href="/" className="flex items-center gap-3">
            <img src="/images/darklogo.jpg" alt="Funzo Coffee Logo" className="w-16 h-16"/>
            <div className="flex flex-col leading-tight">
              <span className="font-bold text-coffee-dark text-xl">Funzo Coffee Limited</span>
            </div>
          </a>
          <button className="xl:hidden p-2" onClick={toggleMenu} aria-label="Toggle navigation menu">
            <img src="https://api.iconify.design/lucide-menu.svg?color=%235C3A21" alt="Menu icon" className="w-6 h-6"/>
          </button>
          <nav className={`${isMenuOpen ? 'flex flex-col absolute top-full left-0 w-full bg-white/90 shadow-md z-40' : 'hidden'} xl:flex xl:flex-row xl:w-auto xl:relative xl:shadow-none xl:items-center xl:gap-4`}>
            <a href="/" className="text-md text-coffee-dark hover:text-coffee-accent hover:underline underline-offset-4 py-2 px-2">Home</a>
            <a href="/coffee" className="text-md text-coffee-dark hover:text-coffee-accent hover:underline underline-offset-4 py-2 px-2">Our Coffee</a>
            {/* <a href="/value" className="text-md text-coffee-dark hover:text-coffee-accent hover:underline underline-offset-4 py-2 px-2">Value Addition</a> */}
            <a href="/sustainability" className="text-md text-coffee-dark hover:text-coffee-accent hover:underline underline-offset-4 py-2 px-2">Sustainability</a>
            <a href="/blog" className="text-md text-coffee-dark hover:text-coffee-accent hover:underline underline-offset-4 py-2 px-2">Blog</a>
            <a href="/gallery" className="text-md text-coffee-dark hover:text-coffee-accent hover:underline underline-offset-4 py-2 px-2">About</a>
            <a href="/contact" className="text-md text-coffee-dark hover:text-coffee-accent hover:underline underline-offset-4 py-2 px-2">Contact</a>
            <a href="/contact" className="hidden xl:inline-flex items-center gap-1 px-4 py-2 bg-coffee-primary text-white rounded-md shadow-md hover:bg-coffee-secondary focus:outline-none focus:ring-2 focus:ring-coffee-accent">
              <img src="https://api.iconify.design/lucide-message-circle.svg?color=%23FFFFFF" alt="Message icon" className="w-5 h-5"/>
              <span>Talk to Us</span>
            </a>
          </nav>
      </div>
    </header>
  );
}

export default Header;
